import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "reviews-rating-facets" }
const _hoisted_2 = { class: "reviews-rating-facets__overall-rating" }
const _hoisted_3 = { class: "reviews-rating-facets__title" }
const _hoisted_4 = { class: "reviews-rating-facets__average-rating" }
const _hoisted_5 = { class: "reviews-rating-facets__stars" }
const _hoisted_6 = { class: "reviews-rating-facets__rating-breakdown" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "reviews-rating-facets__rating-count" }
const _hoisted_9 = {
  key: 1,
  class: "reviews-rating-facets__show-reviews-placeholder"
}

import { ref, computed } from 'vue';

import { getReviewsContext } from '@/composables/useReviews';
import useWebsiteTexts from '@/composables/useWebsiteTexts';

import ReviewStars from './ReviewStars.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewsRatingFacets',
  setup(__props) {

const {
  ratingDistribution,
  totalReviews,
  reviewsRatingAverage,
  addFacet,
  removeFacet,
} = getReviewsContext();
const { websiteText } = useWebsiteTexts();

const selectedRating = ref<number | null>(null);

function handleSelectRating(key: number, value: number) {
  if (!value) return;

  if (selectedRating.value === key) {
    selectedRating.value = null;
    removeFacet('productRating', (key / 5).toFixed(1));
    return;
  }
  if (selectedRating.value !== null) {
    removeFacet('productRating', (selectedRating.value / 5).toFixed(1));
  }
  selectedRating.value = key;
  addFacet('productRating', (key / 5).toFixed(1));
}

function handleSeeAllReviews() {
  if (!selectedRating.value) return;

  removeFacet('productRating', (selectedRating.value / 5).toFixed(1));
  selectedRating.value = null;
}

const displayAllReviewsButton = computed(() => selectedRating.value !== null);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(websiteText)('review_customer_reviews').value), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(reviewsRatingAverage) || 0), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(ReviewStars, { rating: _unref(reviewsRatingAverage) }, null, 8, ["rating"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ratingDistribution)?.entries(), ([key, value]) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "reviews-rating-facets__rating-row",
          onClick: ($event: any) => (handleSelectRating(key, value))
        }, [
          _createVNode(ReviewStars, { rating: key }, null, 8, ["rating"]),
          _createElementVNode("div", {
            class: _normalizeClass({
            'reviews-rating-facets__rating-bar': true,
            'reviews-rating-facets__rating-bar--active': key === selectedRating.value,
          })
          }, [
            _createElementVNode("div", {
              class: "reviews-rating-facets__bar",
              style: _normalizeStyle({ width: `${(value / _unref(totalReviews)) * 100}%` })
            }, null, 4)
          ], 2),
          _createElementVNode("div", _hoisted_8, _toDisplayString(value), 1)
        ], 8, _hoisted_7))
      }), 128)),
      (_unref(displayAllReviewsButton))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "reviews-rating-facets__show-reviews",
            onClick: handleSeeAllReviews
          }, [
            _createTextVNode(_toDisplayString(_unref(websiteText)('reviews_showing_rating', {
            rating: selectedRating.value?.toString() || '',
          }).value) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(websiteText)('reviews_show_all').value), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9))
    ])
  ]))
}
}

})